import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function TotalbyaccountReducer(state = initialState.totalbyaccountContent, action: any) {
  switch (action.type) {
    case types.SAVE_TOTALBYACCOUNTCONTENT_SUCCESS:
      return action.totalbyaccountContent;
    default:
      return state;
  }
}
